
const getWireflowVariations = (commonCanopies, commonVariaton) => {

	const wireflowBase = {
		...commonVariaton,
		familyName: 'wireflow',
		related: ['0345', '0361'],
		canopy: {
			...commonCanopies,
			"10": {
				...commonCanopies['10'],
				source: '/models/canopy_wireflow.glb',
				size: {
					width: 0.2,
					depth: 0.2,
					height: 0.038
				}
			}
		},
		light: {
			type: 'spot',
			power: 490,
			options: {
				angle: Math.PI / 6
			}
		}
	}

	return {
		'0345': {
			...wireflowBase,
			size: {
				width: 0.052,
				height: 0.12,
				depth: 0.052
			}
		},
		'0361': {
			...wireflowBase,
			size: {
				width: 0.052,
				height: 0.09,
				depth: 0.052
			}
		}
	}
}

export default getWireflowVariations